module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Ear9"))).then(() => parcelRequire('ikE14'));